import React from "react";
import {
    Box,
    IconButton,
    Modal,
    Typography,
} from "@mui/material";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";


const LpModal = ({ children, open, handleModalClose }) => {
    return (
        <Modal
            open={open}
            onClose={handleModalClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
        >
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "95vw",
                    boxShadow: 24,
                    padding: "35px 50px",
                    textAlign: "center",
                    backgroundColor: "#16b855",
                    color: "white",
                    maxWidth: "640px",
                    borderRadius: "16px",
                    "@media (max-width: 480px)": {
                        padding: "45px 20px",
                    },
                }}
            >
                <div>
                    <IconButton
                        sx={{
                            position: "absolute",
                            top: "4px",
                            right: "4px",
                        }}
                        onClick={handleModalClose}
                    >
                        <CancelRoundedIcon sx={{ fill: "black" }} />
                    </IconButton>
                </div>
                {children}
            </Box>
        </Modal>

    )
}


export default LpModal
